/**
 * <drag-slider> — the theme's slider-element plus mouse drag-to-scroll.
 * Touch devices already swipe natively via overflow scroll; this only
 * handles mouse pointers. Used by sections/testimonial-carousel.liquid.
 */
(() => {
  const define = () => {
    const SliderElement = customElements.get('slider-element');
    if (!SliderElement || customElements.get('drag-slider')) return;

    class DragSlider extends SliderElement {
      connectedCallback() {
        super.connectedCallback();

        this.dragState = null;
        this.on(this, 'pointerdown', this.onPointerDown.bind(this));
        this.on(this, 'pointermove', this.onPointerMove.bind(this));
        this.on(this, 'pointerup', this.onPointerEnd.bind(this));
        this.on(this, 'pointercancel', this.onPointerEnd.bind(this));
        this.on(this, 'click', this.onClickCapture.bind(this), { capture: true });
        this.on(this, 'dragstart', (event) => event.preventDefault());
      }

      onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScroll: this.scrollLeft,
          dragging: false
        };
      }

      onPointerMove(event) {
        const state = this.dragState;
        if (!state || event.pointerId !== state.pointerId) return;

        const delta = event.clientX - state.startX;
        if (!state.dragging) {
          if (Math.abs(delta) < 5) return;
          state.dragging = true;
          try { this.setPointerCapture(state.pointerId); } catch { /* pointer already gone */ }
          this.classList.add('is-dragging');
          this.style.scrollSnapType = 'none';
          this.style.scrollBehavior = 'auto';
        }

        this.scrollLeft = state.startScroll - delta;
      }

      onPointerEnd(event) {
        const state = this.dragState;
        if (!state || event.pointerId !== state.pointerId) return;
        this.dragState = null;
        if (!state.dragging) return;

        try { this.releasePointerCapture(state.pointerId); } catch { /* pointer already gone */ }
        this.classList.remove('is-dragging');
        this.style.scrollBehavior = '';

        // Swallow the click that follows a drag so it can't hit a card.
        this.suppressClick = true;
        setTimeout(() => (this.suppressClick = false), 100);

        // Smooth-scroll to the nearest card, then re-enable CSS snapping.
        const offset = this.itemOffset;
        if (offset > 0) {
          this.scrollToPosition(Math.round(this.scrollLeft / offset) * offset);
        }
        this.on(this, 'scrollend', () => (this.style.scrollSnapType = ''), { once: true });
        setTimeout(() => (this.style.scrollSnapType = ''), 600);
      }

      onClickCapture(event) {
        if (!this.suppressClick) return;
        this.suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }
    }

    customElements.define('drag-slider', DragSlider);
  };

  if (customElements.get('slider-element')) define();
  else document.addEventListener('DOMContentLoaded', define, { once: true });
})();
